import * as Sentry from '@sentry/vue'
import * as pkg from '~/package.json'
import type { TGeneral } from '~/types/app.type'

export default defineNuxtPlugin(({ $router, vueApp, $config }) => {
  if ($config.public.sentry.enabled) {
    const release = `${pkg.name}@${pkg.version}`

    Sentry.init({
      app: vueApp,
      dsn: $config.public.sentry.dsn,
      release,
      environment: $config.public.sentry.environment,
      integrations: [
        Sentry.browserTracingIntegration({
          router: $router,
        } as TGeneral),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
        }),
        Sentry.replayCanvasIntegration(),
        Sentry.vueIntegration({
          app: vueApp,
          tracingOptions: { trackComponents: true },
        }),
      ],
      sampleRate: 0.5,
      tracesSampleRate: 0.3,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.3,
    })
  }
})
